/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'move-side': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.414 16.586a2 2 0 010 2.828L5.828 24l4.586 4.586a2 2 0 11-2.828 2.828l-6-6a2 2 0 010-2.828l6-6a2 2 0 012.828 0zM37.586 16.586a2 2 0 012.828 0l6 6a2 2 0 010 2.828l-6 6a2 2 0 11-2.828-2.828L42.172 24l-4.586-4.586a2 2 0 010-2.828z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1 24c0-1.105.936-2 2.09-2h41.82c1.154 0 2.09.895 2.09 2s-.936 2-2.09 2H3.09C1.937 26 1 25.105 1 24z" _fill="#000"/>'
  }
})
